import { Directive, HostListener, Input } from '@angular/core';
import { AppEvent, AppEventTypeEnum, EventDispatcherService } from 'taxtank-core';

@Directive({
  selector: '[appOpenChat]',
  standalone: false
})
export class OpenChatDirective {
  @Input('appOpenChat') employeeId: number;

  constructor(
    private eventDispatcherService: EventDispatcherService
  ) { }

  @HostListener('click')
  onClick(): void {
    this.eventDispatcherService.dispatch(new AppEvent(AppEventTypeEnum.CLIENT_OPEN_CHAT, this.employeeId));
  }
}
